import axios from "axios";
import Cookies from "js-cookie";
export const cookieOptions = {
    path: "/",
    secure: process.env.NEXT_PUBLIC_ENV !== "development",
    domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN
};
const getDefaultTransfrom = (func)=>func ? Array.isArray(func) ? func : [
        func
    ] : [];
export const defaultTransformRequest = getDefaultTransfrom(axios.defaults.transformRequest);
export const defaultTransformResponse = getDefaultTransfrom(axios.defaults.transformResponse);
const transformRequest = [
    (data)=>{
        // return snakeize(data)
        return data;
    },
    ...defaultTransformRequest
];
const solvookAPIConfig = {
    baseURL: process.env.NEXT_PUBLIC_API_ENDPOINT,
    responseType: "json",
    transformRequest,
    // headers: { Authorization: Cookies.get('accessToken') },
    transformResponse: [
        ...defaultTransformResponse,
        (data)=>{
            // return camelize(data)
            return data;
        }
    ]
};
const axiosInstance = axios.create(solvookAPIConfig);
export const getAccessToken = ()=>{
    return Cookies.get("accessToken", {
        ...cookieOptions
    });
};
const setupInterceptors = (ax)=>{
    ax.interceptors.request.use((config)=>{
        const accessToken = getAccessToken();
        if (accessToken) {
            config.headers.Authorization = accessToken;
        }
        return config;
    }, (error)=>{
        return Promise.reject(error);
    });
};
setupInterceptors(axiosInstance);
export const api = axiosInstance;
const axiosVersions = {
    market: {
        baseURL: "".concat(process.env.NEXT_PUBLIC_MARKET_API_ENDPOINT)
    },
    expertKo: {
        baseURL: "".concat(process.env.NEXT_PUBLIC_EXPERT_KO_API_ENDPOINT)
    },
    expertEn: {
        baseURL: "".concat(process.env.NEXT_PUBLIC_EXPERT_EN_API_ENDPOINT)
    }
};
export const otherApiClient = Object.entries(axiosVersions).reduce((acc, param)=>{
    let [k, v] = param;
    const instance = axios.create({
        ...solvookAPIConfig,
        ...v
    });
    setupInterceptors(instance);
    acc[k] = instance;
    return acc;
}, {});
/**
 * BE 사유 코드. 실어 나르는 자리가 API 마다 다르다.
 * - 에러: NestJS Exception 의 message (예: `throw new ForbiddenException('SUBSCRIPTION_EXPIRED')`)
 * - 정상 응답: 본문 필드 (예: `check-can-open` 의 `reason`)
 *
 * 사용자에게 그대로 노출할 문구가 아니다 — 화면 문구는 FE 가 코드별로 갖는다.
 */ export const ApiErrorCode = {
    /** 월구독이 무효(결제 실패·만료)해서 보유 자료를 이용할 수 없음 */ SubscriptionExpired: "SUBSCRIPTION_EXPIRED"
};
/**
 * 에러 객체에서 코드를 꺼낸다. NestJS 는 상황에 따라 message 를 배열로도 내보내므로 양쪽을 받는다.
 *
 * `check-can-open` 처럼 200 응답 본문(`reason`)으로 사유를 주는 API 도 있어 코드 문자열을 그대로 받는다.
 */ export const getApiErrorCode = (source)=>{
    var _source_response, _source_response_data;
    if (typeof source === "string") return source;
    if (!axios.isAxiosError(source)) return undefined;
    const message = (_source_response = source.response) === null || _source_response === void 0 ? void 0 : (_source_response_data = _source_response.data) === null || _source_response_data === void 0 ? void 0 : _source_response_data.message;
    const code = Array.isArray(message) ? message[0] : message;
    // data 가 any 라 응답 형식이 바뀌면 문자열이 아닌 값이 올 수 있다. 반환 타입을 지킨다.
    return typeof code === "string" ? code : undefined;
};
export const isSubscriptionExpiredError = (error)=>getApiErrorCode(error) === ApiErrorCode.SubscriptionExpired;
